export default function PHP_nl_langinfo() {
  return (
    <div>
      <h1>PHP_nl_langinfo</h1>
    </div>
  );
}
